import React from 'react';
import { SlidersHorizontal, X } from 'lucide-react';
import Drawer from './Drawer';
import { Button } from './ui/button';

export function FilterCount({ count }) {
    if (!count) return null;
    return (
        <span className="absolute -right-2 -top-2 h-5 min-w-5 rounded-full bg-primary-600 px-1 text-[11px] font-semibold leading-5 text-white text-center">
            {count}
        </span>
    );
}

/** Ação do PageHeader que abre o drawer de filtros. */
export function toFilterAction({ count, onClick }) {
    return {
        label: (
            <>
                Filtros
                <FilterCount count={count} />
            </>
        ),
        icon: <SlidersHorizontal className="w-4 h-4" />,
        variant: 'outline',
        onClick,
        className: 'relative shrink-0',
    };
}

/** Drawer de filtros com rodapé Limpar + Aplicar filtros. */
function FilterDrawer({ open, onClose, onApply, onClear, children }) {
    return (
        <Drawer
            open={open}
            onClose={onClose}
            title="Filtros"
            size="sm"
            footer={
                <div className="flex gap-3">
                    <Button type="button" variant="outline" className="flex-1" onClick={onClear}>
                        <X className="w-4 h-4" />
                        Limpar
                    </Button>
                    <Button type="button" className="flex-1" onClick={onApply}>
                        Aplicar filtros
                    </Button>
                </div>
            }
        >
            <div
                className="space-y-4"
                onKeyDown={(e) => {
                    if (e.key !== 'Enter' || e.defaultPrevented || e.target.tagName !== 'INPUT') return;
                    e.preventDefault();
                    onApply();
                }}
            >
                {children}
            </div>
        </Drawer>
    );
}

export default FilterDrawer;
